import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SubmitResult, SupportQueryParams } from '../models/support.interface';
import {
    CreateTicketPicklist,
    TicketPicklist
} from '../../../../common/models/support-picklist.interface';

import { SupportService } from '../support.service';
import { ListTicketService } from '../list-tickets/list-ticket.service';
import { CreateTicketPicklistService } from './create-ticket-picklist.service';
import { SupportTicket } from '../models/support-ticket';
import { AuthStateService } from '../../shared/services/auth-state.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-support',
    styleUrls: ['./create-ticket.component.sass'],
    templateUrl: './create-ticket.component.html'
})
export class CreateTicketComponent implements OnInit, OnDestroy {
    apps: CreateTicketPicklist[];
    private sub;
    ticket: SupportTicket;
    formSubmit: SubmitResult;
    error: any;
    inProgress = false;
    isSubmitted = false;
    isInternalAccessRequest = false;

    hero = {
        title: 'Welcome to Quotient Business Support',
        lead: 'Fill out each field accordingly. We will respond within a business day.'
    };

    constructor(
        private router: Router,
        private supportService: SupportService,
        private activatedRoute: ActivatedRoute,
        private ticketService: ListTicketService,
        private picklistService: CreateTicketPicklistService,
        private authStateService: AuthStateService,
        private sanitizer: DomSanitizer
    ) {}

    accessRequestMessage: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(
        `Note: Please reach out to your Account Contact for getting access to any of the Quotient Business Applications.`
    );

    ngOnInit() {
        this.ticket = new SupportTicket();
        let queryParams: SupportQueryParams;
        this.sub = this.activatedRoute.queryParams.subscribe(params => {
            queryParams = params as SupportQueryParams;
        });

        this.picklistService.ticketPicklist.subscribe((data: CreateTicketPicklist[]) => {
            this.apps = data.filter(app => app.accessKey === 'analytics');
            if (queryParams && queryParams.app) {
                this.prefillFormFields(data, queryParams);
            }
        });
    }

    onAppChange() {
        this.ticket.selectedTicketType = '';
        this.ticket.selectedReason = '';
    }

    onTicketTypeChange() {
        this.ticket.selectedReason = '';
    }

    /**
     * @param apps - create ticket form picklist
     * @param params - ?app=axis&ticket_type=coupon_creation&reason=io&url=http:%2F%2Fcoupons.com
     */
    prefillFormFields(apps, params) {
        /* No matter what user type, we need to show the view made for 
        isInternalAccessRequest as true for request access action.
        Below we will just set what message is to be shown based on user type */
        //TODO: The above is true except QTA app. They actually append query param in that as well. And this function is
        //invoked based on query param
        this.isInternalAccessRequest = true;
        if (apps && params.app) {
            this.ticket.selectedApp = apps.filter(app => app.accessKey === params.app)[0];
        }
        if (this.ticket.selectedApp.accessKey === 'analytics') {
            this.isInternalAccessRequest = false;
        }
        if (params.ticket_type) {
            this.ticket.selectedTicketType = this.ticket.selectedApp.ticketTypes.filter(
                ticketType => ticketType.key === params.ticket_type
            )[0];

            if (
                this.ticket.selectedTicketType &&
                this.ticket.selectedTicketType.key === 'app_access' &&
                this.authStateService.isLoggedInInternalUser()
            ) {
                this.accessRequestMessage = this.sanitizer.bypassSecurityTrustHtml(`Please create a
                                <a href="https://support.quotient.com/hc/en-us"
                                    >CRE/CISupport ticket</a
                                >
                                and select <b>Product</b> as “Quotient Business Apps Access“,
                                provide application name and user details in description and add/tag
                                your manager for approval to request access to Quotient Business
                                Apps.`);
            }
        }
        if (params.reason) {
            this.ticket.selectedReason = this.ticket.selectedTicketType.ticketReasons.filter(
                reason => reason.key === params.reason
            )[0];
        }
        if (params.custom_description) {
            this.ticket.description = params.custom_description;
        }
        if (params.url) {
            this.ticket.description = `${this.ticket.description}\nApp url: ${params.url}`;
        }
    }

    createTicket(createTicketForm) {
        if (createTicketForm.valid) {
            this.inProgress = true;
            this.supportService.createTicket(this.ticket.toPayload()).subscribe(response => {
                this.inProgress = false;
                this.isSubmitted = true;

                // createTicketForm.reset();
                this.formSubmit = {
                    isSuccess: true,
                    message: response.key
                };
            });
        }
    }

    gotoTicket(key) {
        this.router.navigate(['/support/tickets', key]);
    }

    cancel() {
        if (this.hasTickets()) {
            this.router.navigate(['/support/tickets']);
        } else {
            this.router.navigate(['/']);
        }
    }

    onCreateNew() {
        this.isSubmitted = false;
        this.ticket = new SupportTicket();
    }

    hasTickets(): boolean {
        let hasTickets;
        this.ticketService.jiraTickets.subscribe(data => (hasTickets = data.length > 0));
        return hasTickets;
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
